import React from 'react';
import StatusContext from '../../../contexts/StatusContext'

import "./aitest.css"

export const BuyTest = ({ price, handleBuy }) => {

  let {
    changeLanguage,
  } = React.useContext(StatusContext);


  return (
    <button className="aitestBuyButton" onClick={handleBuy}>
      {parseFloat(price) !== 0 ? `${changeLanguage('aitest', 'buytest')} $${price}` : changeLanguage('aitest', 'free')}
    </button>
  );
};

